import React, { Component } from 'react'
import './Product.css'

export default class Product extends Component {
  render() {
    return (
      <div className={`product ${this.props.brightness}`}>
        <div className='product-name'>{this.props.name}</div>
        <div className='product-subtitle'>{this.props.subtitle}</div>
        <div className='cta-links'>
          <a href='' className='button'>
            Learn more &gt;
          </a>
          <a href='' className='button'>
            Buy &gt;
          </a>
        </div>
        <img src={this.props.image} alt={this.props.name} width={'40%'} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/home/Product.js